var rendererStorage = {};
rendererStorage.html = {
    update: function (dom, content) { return dom.innerHTML = content + ''; },
    destroy: function (dom) { return dom.innerHTML = ''; },
};
export function getDOMRenderer(type) {
    return rendererStorage[type];
}
export function registerDOMRenderer(type, renderer) {
    rendererStorage[type] = renderer;
}
export function createReactRenderer(ReactDOM) {
    return {
        update: function (dom, content) { return ReactDOM.render(content, dom); },
        destroy: function (dom) { return ReactDOM.unmountComponentAtNode(dom); },
    };
}
